import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SelfServiceIndex = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to Model Management (first child) when parent route is accessed
    navigate('/selfservice/models', { replace: true });
  }, [navigate]);

  // Return null since we're redirecting immediately
  return null;
};

export default SelfServiceIndex;
